<template>
  <div>
    <div style="background:rgba(249, 249, 249, 1);padding-bottom:20px;">
      <div class="box">
        <img :src="cover" />
      </div>
    </div>
    <div class="regions">
      {{$t('coverage.title0')}}
      <span
        style="color: rgba(250, 86, 75, 1);font-weight:bold;font-size:22px;"
      >100+</span>
      {{$t('coverage.title')}}
    </div>
    <div class="article" style="padding-top:0.4rem;">
      <div class="title">
        <img src="../../assets/article/定位@3x.png" />
        {{$t('coverage.title1')}}
      </div>
      <div class="content">{{$t('coverage.text1')}}</div>
      <div class="title">
        <img src="../../assets/article/定位@3x.png" />
        {{$t('coverage.title2')}}
      </div>
      <div class="content">{{$t('coverage.text2')}}</div>
      <div class="title">
        <img src="../../assets/article/定位@3x.png" />
        {{$t('coverage.title3')}}
      </div>
      <div class="content">{{$t('coverage.text3')}}</div>
      <div class="title">
        <img src="../../assets/article/定位@3x.png" />
        {{$t('coverage.title4')}}
      </div>
      <div class="content">{{$t('coverage.text4')}}</div>
      <div class="title">
        <img src="../../assets/article/定位@3x.png" />
        {{$t('coverage.title5')}}
      </div>
      <div class="content">{{$t('coverage.text5')}}</div>
      <div class="title">
        <img src="../../assets/article/定位@3x.png" />
        {{$t('coverage.title6')}}
      </div>
      <div class="content">{{$t('coverage.text6')}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'coverage',
  computed: {
    cover() {
      return this.$store.state.cover
    }
  }
}
</script>
<style scoped lang="less">
.box {
  width: 750px;
  margin: auto;
  padding: 0.5rem 0;
}
@media screen and (max-width: 1200px) {
  .box {
    width: 100%;
    margin: 1rem 0 0 0;
    padding: 0.2rem;
  }
}
.title {
  font-family: 'Poppins-Light';
  font-size: 14px;
  text-align: left;
  margin-bottom: 0.1rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  img {
    width: 14px;
    margin: 0 10px 4px 0;
  }
}
.content {
  font-family: 'Poppins-Light';
  font-size: 14px;
  margin-bottom: 0.4rem;
  text-align: left;
}
.regions {
  font-family: 'Poppins-Light';
  font-size: 18px;
  text-align: center;
  margin-top: -40px;
}
@media screen and (max-width: 1000px) {
  .regions {
    font-family: 'Poppins-Light';
    font-size: 0.12rem;
    text-align: center;
    margin-top: -40px;
  }
}
</style>
